import { SxProps, Theme } from "@mui/material";

export const crashCourseHeaderStyles: SxProps<Theme> = {
  mb: 1,
};

export const crashCourseTitleStyles: SxProps<Theme> = {
  fontWeight: 400,
  fontSize: "16px",
  mb: 0.5,
};

export const crashCourseImageStyles: SxProps<Theme> = {
  width: "100%",
  borderRadius: 2,
  mb: 1,
};

export const crashCourseContentStyles: SxProps<Theme> = {
  fontFamily: '"Red Hat Display", sans-serif',
  mb: 1,
};

export const crashCourseFooterStyles: SxProps<Theme> = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

export const crashCourseDateStyles: SxProps<Theme> = {
  fontWeight: 500,
  fontSize: "12px",
};

export const crashCourseBadgeStyles: SxProps<Theme> = {
  fontWeight: 500,
  fontSize: "12px",
  px: 1,
  py: 0.5,
  borderRadius: 1,
};
